import { render } from "./MyofficeNewMain.vue?vue&type=template&id=dc82488c&scoped=true"
import script from "./MyofficeNewMain.vue?vue&type=script&lang=js"
export * from "./MyofficeNewMain.vue?vue&type=script&lang=js"

import "./MyofficeNewMain.vue?vue&type=style&index=0&id=dc82488c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc82488c"]])

export default __exports__